// Routes that render without authentication. Kept in sync with the public
// (non-ProtectedRoute) routes in src/App.tsx.
//
// The auth bootstrap in use-auth.tsx consults this list to decide whether to
// attempt a silent token refresh on mount. Skipping the refresh on public
// routes prevents unauthenticated visitors (e.g. share-link recipients in an
// incognito window) from being redirected to /login before the target page
// has a chance to render.
const PUBLIC_ROUTE_PATTERNS = [
    /^\/login$/,
    /^\/terms$/,
    /^\/privacy$/,
    /^\/forgot-password$/,
    /^\/reset-password\/[^/]+$/,
    /^\/invite\/accept\/[^/]+$/,
    // Teleconsultation-group invitation landing (/invite/group/:region/:token).
    /^\/invite\/group\/[^/]+\/[^/]+$/,
    // SSO callback landing page — user arrives unauthenticated (the handoff token
    // is in the hash, not a session). Kept public so no silent-refresh race fires.
    /^\/auth\/sso\/finish$/,
    // NewLumen Link email verification landing — arrives from the confirmation
    // email, so the visitor may have no session (a different browser/device
    // than the one they signed up in). Must skip the silent-refresh bootstrap
    // like every other anonymous Link surface, below.
    /^\/verify-email\/[^/]+$/,
    // Emailed report-PDF download landing (tokened, no session expected).
    /^\/report-download\/[^/]+$/,
    // Share-link viewer: /study/:studyId. The negative lookahead excludes
    // /study/list, which is the protected worklist route.
    /^\/study\/(?!list$)[^/]+$/,
    // NewLumen Link (free referring-practice tier) anonymous surfaces: the
    // untokenized explainer, the sign-in page, and the /link/:code enrollment
    // landing. The negative lookahead excludes /link/app, the authenticated shell.
    // Case-insensitive on purpose: the URL is spoken aloud and printed on
    // handouts ("newlumen.ai/Link"), and wouter's own matching is already
    // case-insensitive — these must classify identically or /Link would
    // silent-refresh and bounce an anonymous visitor to /login.
    /^\/link$/i,
    /^\/link\/signin$/i,
    /^\/link\/(?!app(?:\/|$))[^/]+$/i,
];
export function isPublicRoute(pathname) {
    return PUBLIC_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
}
